import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';

export const Layout = ({
  sidebar,
  header,
  main,
  footer,
  mobileNav,
  classNames: classes = {},
  sidebarRef,
  headerRef,
  bodyRef,
  asideRef,
  mobile,
  tablet,
  sidebarOpen,
  toggleSidebar,
  resizeAside,
  toggleAside,
  asideWidth,
  environment,
  location,
}) => {
  // Scroll main content to top on pathname change
  const mainScrollRef = useRef();
  useEffect(
    () => {
      if (mainScrollRef.current) mainScrollRef.current.scroll({ top: 0 });
    },
    [location.pathname],
  );

  return (
    <>
      {environment &&
        environment !== 'PRD' && (
          <div className="app-environment">
            {environment === 'DEV'
              ? 'Development Environment'
              : environment === 'PPD'
                ? 'Pre-Production Environment'
                : `${environment} Environment`}
          </div>
        )}
      <div className="app-wrapper">
        {!!sidebar && (
          <nav
            className={classNames('app-sidebar', {
              // closed: !mobile && sidebarOpen === -1,
              // closing: !mobile && sidebarOpen === 0,
              open: (mobile || tablet) && sidebarOpen > 0,
            })}
            ref={sidebarRef}
          >
            {sidebar}
          </nav>
        )}

        <div
          className={classNames('app-body', classes.body)}
          ref={bodyRef}
          onClick={
            (mobile || tablet) && !!sidebar && sidebarOpen > 0
              ? toggleSidebar
              : undefined
          }
        >
          {!!header && (
            <header
              className={classNames(
                'app-header app-header--sticky',
                classes.header,
              )}
              ref={headerRef}
              style={
                asideWidth && !mobile
                  ? { marginRight: `-${asideWidth[1]}px` }
                  : undefined
              }
            >
              {header}
            </header>
          )}

          <div
            className={classNames('app-main', classes.main)}
            style={
              asideWidth && !mobile
                ? { marginRight: `-${asideWidth[1]}px` }
                : undefined
            }
            ref={mainScrollRef}
          >
            {main}
            {!!footer && (
              <footer className={classNames('app-footer', classes.footer)}>
                {footer}
              </footer>
            )}
          </div>

          {mobile &&
            !!mobileNav && (
              <nav className={classNames('app-mobile-nav', classes.mobileNav)}>
                {mobileNav}
              </nav>
            )}
        </div>
        <aside
          className="app-aside"
          id="app-aside"
          ref={asideRef}
          style={
            asideWidth && !mobile
              ? { flexBasis: `${asideWidth[0]}px` }
              : undefined
          }
        >
          <div className="controls" onMouseDown={resizeAside}>
            <button
              className="aside-toggle"
              aria-label="Toggle Aside"
              onClick={toggleAside}
              onMouseDown={e => e.stopPropagation()}
            >
              <span className="fa fa-chevron-right" />
            </button>
          </div>
        </aside>
      </div>
    </>
  );
};
